import Amenity from '@customTypes/amenity';
import React, { Dispatch, SetStateAction } from 'react';
import Amenities from '@components/HotelCard/Amenities';
import BottomDrawerVariant from './BottomDrawerVariant';

type Props = {
  amenities: Amenity[];
  isAmenitiesDrawerOpen: boolean;
  setIsAmenitiesDrawerOpen: Dispatch<SetStateAction<boolean>>;
};

function AmenitiesBottomDrawer({
  amenities,
  isAmenitiesDrawerOpen,
  setIsAmenitiesDrawerOpen,
}: Props) {
  return (
    <BottomDrawerVariant
      isOpen={isAmenitiesDrawerOpen}
      setIsOpen={setIsAmenitiesDrawerOpen}
      title="Amenities"
    >
      <div className="flex flex-col space-y-4 py-5 px-4 w-full">
        <Amenities amenities={amenities} direction="vertical" variant="expanded" size="large" />
      </div>
    </BottomDrawerVariant>
  );
}

export default AmenitiesBottomDrawer;
